import Spoiler from './Spoiler'

export default Spoiler
